<template>
    <div>
        <v-container fluid>
            <v-row>
                <v-col cols="6" sm="3" lg="2">
                    <v-text-field
                        v-model="conditionsName"
                        type="text"
                        label="名前">
                    </v-text-field>
                </v-col>

                <v-col cols="6" sm="3" lg="2">
                    <v-select
                        v-model="conditionsShopId"
                        :items="shops"
                        label="支店"
                    ></v-select>
                </v-col>

                <v-col cols="6" sm="3" lg="2">
                    <v-select
                        v-model="conditionsCounselorId"
                        :items="counselors"
                        label="担当CO"
                    ></v-select>
                </v-col>

                <v-col cols="6" sm="3" lg="2">
                    <v-select
                        v-model="conditionsAge"
                        :items="ageList"
                        label="年齢"
                    ></v-select>
                </v-col>
            </v-row>
        </v-container>
        <v-data-table
            v-model="selected"
            :headers="headers"
            :items="histories"
            :items-per-page="histories.length"
            :loading="loading"
            show-select
            hide-default-footer
            dense
            :search="search"
            :custom-filter="customFilter"
            :single-select="!isMultiple"
        >
            <template v-slot:[`header.data-table-select`]="{}"></template>
            <template v-slot:[`item.counselor`]="{ item }">
                {{ showCounselorName(item.counselor_id) }}
            </template>
            <template v-slot:[`item.shop`]="{ item }">
                {{ showShopName(item.shop_id) }}
            </template>
            <template v-slot:[`item.age`]="{ item }">
                {{item.age}}歳
            </template>
            <template v-slot:[`item.history`]="{ item }">
                {{showHistory(item.histories)}}
            </template>
        </v-data-table>

        <v-container v-if="onSave!==undefined">
            <v-row dense>
                <v-col class="text-center">
                    <v-btn
                        @click="save()"
                        dark
                        class="info"
                    >保存
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>

        <v-container v-if="onCancel!==undefined || onSubmit!==undefined">
            <v-row dense>
                <v-col class="text-center">
                    <v-btn
                        @click="cancel()"
                        v-if="onCancel!=undefined"
                    >キャンセル
                    </v-btn>
                    <v-btn
                        @click="submit()"
                        dark
                        class="info"
                        v-if="onSubmit!=undefined"
                    >決定
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import utilDatetime from "@/utilities/datetime.js"
export default {
    name: 'select_matching',
    mixins: [utilDatetime],
    props: ["isMultiple", "onSave", "onCancel", "onSubmit"],
    data: () => ({
        reserves: [],
        histories: [],
        loading: true,
        selected: [],
        headers: [
            { text: "No.", value: "id", align: "start", sortable: false },
            { text: "名前", value: "name", align: "start", sortable: false },
            { text: "支店", value: "shop", align: "start", sortable: false },
            { text: "担当CO", value: "counselor", align: "start", sortable: false },
            { text: "年齢", value: "age", align: "start", sortable: false },
            { text: "履歴", value: "history", align: "start", sortable: false },
            { text: "", value: "data-table-select" }
        ],
        customer: {
            shop_id: null,
            counselor_id: null,
            number: "",
            valid_mail: false,
            family_name: "",
            given_name: "",
            family_name_kana: "",
            given_name_kana: "",
            gender: 1,
            blood_type: 1,
            birthday: "",
            phone_number: "",
            phone_number_home: "",
            email_address: "",
            zip: "",
            pref: 0,
            address1: "",
            address2: "",
            building_name: "",
        },
        counselors: [],
        shops: [],
        ageList: [
            { value:  0, text: "全て" },
            { value: 20, text: "20代" },
            { value: 30, text: "30代" },
            { value: 40, text: "40代" },
            { value: 50, text: "50代" },
            { value: 60, text: "60代～" }
        ],
        conditionsName: '',
        conditionsShopId: 0,
        conditionsCounselorId: 0,
        conditionsAge: 0,
        search: "",
    }),
    watch: {
        conditionsName() { this.search = this.getFilter(); },
        conditionsShopId() { this.search = this.getFilter(); },
        conditionsCounselorId() { this.search = this.getFilter(); },
        conditionsAge() { this.search = this.getFilter(); },
        selected(val, oldVal) {
            if(val.length > 5) {
                // 5件以上は新たにONに出来ない
                this.$nextTick(() => this.selected = oldVal);
            }
        }
    },
    async mounted() {
        await this.loadInit();
    },
    methods: {
        async loadInit() {
            const id = this.$route.params.id;
            const result = await this.$axios
                .get(`/api/v1/customer/${id}/matching_reserve`)
                .then((response) => {
                    return response.data;
                })
                .catch((error) => {
                    return error;
                });

            if (result) {
                this.customer = result.customer;
                this.histories = result.histories;
                this.counselors = result.counselors.map(d => ({ text: d.name, value: d.id }));
                this.counselors.unshift({text: "全て", value: 0});
                this.shops = result.shops.map(d => ({ text: d.name, value: d.id }));
                this.shops.unshift({text: "全て", value: 0});
                if(this.isMultiple) this.selected = result.histories.filter(h => result.reserves.includes(h.id));

                this.reserves = result.reserves;
                
                this.$emit('setCustomer', this.customer);
            }
            this.loading = false;
        },
        getFilter() {
            return this.conditionsName + (this.conditionsShopId > 0 ? 's' : '') + (this.conditionsCounselorId > 0 ? 'c' : '') + (this.conditionsAge > 0 ? 'a' : '');
        },
        customFilter(items, search, filter) {
            if(this.conditionsName.length > 0 && filter.name.indexOf(this.conditionsName) === -1 ) return false;
            if(this.conditionsShopId !== 0 && filter.shop_id != this.conditionsShopId) return false;
            if(this.conditionsCounselorId !== 0 && filter.counselor_id != this.conditionsCounselorId) return false;
            if(this.conditionsAge !== 0) {
                switch(this.conditionsAge) {
                    case 20:    return (filter.age < 30);
                    case 30:    return (30 <= filter.age && filter.age < 40);
                    case 40:    return (40 <= filter.age && filter.age < 50);
                    case 50:    return (50 <= filter.age && filter.age < 60);
                    case 60:    return (60 <= filter.age);
                }
            }
            return true;
        },
        showCounselorName(counselorId) {
            const counselor = this.counselors.find(counselor => counselor.value == counselorId);
            if(!counselor) return '';
            return counselor.text;
        },
        showShopName(shopId) {
            const shop = this.shops.find(shop => shop.value == shopId);
            if(!shop) return '';
            return shop.text;
        },
        showHistory(histories) {
            if(!histories || histories.length == 0) {
                return "無し";
            }

            let result = "";
            const h = histories[0];
            switch(h.kind) {
            case 1: result = "お相手選び";  break;
            case 2: result = "お見合";  break;
            }

            result += `(${h.date})`

            if(histories.length > 1) {
                result += ` 他${histories.length-1}件`;
            }

            return result;
        },
        resetSearch() {
            this.conditionsName = '';
            this.conditionsShopId = 0;
            this.conditionsCounselorId = 0;
            this.conditionsAge = 0;
            this.search = '';
        },
        save() {
            this.onSave(this.selected);
        },
        cancel() {
            this.resetSearch();
            if(this.isMultiple) this.selected = this.histories.filter(h => this.reserves.includes(h.id));
            else this.selected = [];
            this.onCancel();
        },
        submit() {
            this.onSubmit(this.selected);
            this.resetSearch();
        },
    }
}
</script>
